import { useEffect } from 'react';

/**
 * Sets document.title to "{title} — Readwell" while the calling component
 * is mounted. Last writer wins; no restore on unmount (the next mount or
 * route change will set the next title). Satisfies WCAG 2.4.2 (Page Titled).
 *
 * Pass a falsy value to skip — useful while a dynamic title is still loading.
 */
export function useDocumentTitle(title) {
  useEffect(() => {
    if (!title) return;
    document.title = `${title} — Readwell`;
  }, [title]);
}
